import AdvancePayment from '@/store/models/advance-payment';

export default {
  namespaced: true,
  state: {},
  mutations: {},
  actions: {
    init() {},
    terminate() {},
    advancePaymentProps(store, payload) {
      return AdvancePayment.update({
        where: payload.id,
        data: payload.props,
      });
    },
    async updateAdvancePayment({ dispatch }, payload) {
      await dispatch('advancePaymentProps', payload);
      return dispatch('invoices/updateInvoice', {
        invoiceId: payload.invoiceId,
      }, { root: true });
    },
    async addAdvancePayment(store, invoiceId) {
      const paymentCount = AdvancePayment.query().where('invoice_id', invoiceId).count();
      await AdvancePayment.insert({
        data: {
          invoice_id: invoiceId,
          order: paymentCount,
        },
      });
    },
    async removeAdvancePayment(store, paymentId) {
      await AdvancePayment.delete(paymentId);
    },
  },
  getters: {
    byInvoice: () => invoiceId => AdvancePayment.query()
      .where('invoice_id', invoiceId)
      .orderBy('order', 'asc')
      .get(),
  },
};
